<template>
    <div>
        <h1 style="font-size: 24px; color: black;">版块日报
            <span>用户类型：</span>
            <el-select v-model="queryData.user" clearable placeholder="请选择">
                <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <span>模式：</span>
            <el-select v-model="queryData.state" @change="searchAll" placeholder="请选择">
                <el-option v-for="item in stateList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
        </h1>
        <div class="block">
            <span class="demonstration">日期：</span>
            <el-date-picker
                v-model="queryData.timeDate"
                type="daterange"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;&emsp;
            <span>渠道：</span>
            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable
                       placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId" @change="selectSubChannel($event)" clearable placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id"
                           :value="item.subChannel"></el-option>
            </el-select>
            <span>板块名称：</span>
            <el-select :disabled="queryData.state===1" v-model="queryData.pid" clearable filterable
                       placeholder="请选择/输入">
                <el-option
                    v-for="item in showPlateStyles"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>

            <el-button type="primary" class="margin-left-10" @click="query">查询</el-button>
            <el-button type="primary" @click="exportExcel()">导出报表</el-button>
        </div>
        <h1>
            <el-table border :header-cell-style="{background:'#282828'}"
                      :data="plateReportList"
                      ref="filterTable"
                      @sort-change='sortChange'
                      max-height="820">
                <el-table-column prop="dt" label="日期" sortable="custom"></el-table-column>
                <el-table-column label="位置" prop="name">
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>

                <el-table-column label="位置曝光次数" prop="exCount" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.exCount }}
                    </template>
                </el-table-column>


                <el-table-column label="位置曝光用户" prop="exUserCount" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.exUserCount }}
                    </template>
                </el-table-column>

                <el-table-column label="位置曝光率" prop="exRate" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.exRate == null ? '0.00%' : (scope.row.exRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column label="位置点击次数" prop="exClick" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.exClick }}
                    </template>
                </el-table-column>

                <el-table-column label="点击用户数" prop="userClick" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.userClick }}
                    </template>
                </el-table-column>

                <el-table-column label="人均点击次数" prop="userClickPerRate" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.userClickPerRate == null ? '0.00' : scope.row.userClickPerRate.toFixed(2) }}
                    </template>
                </el-table-column>

                <el-table-column label="用户点击率" sortable="custom">
                    <template slot-scope="scope">
                        {{
                            scope.row.userClickRate == null ? '0.00%' : (scope.row.userClickRate * 100).toFixed(2) + '%'
                        }}
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[20,30,50]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
import {channelList, discoverList, downloadData, eventListByType, plateReportSearch, plateRuleList,} from "@/http/api";
import utils from '@/utils'

export default {
    name: "FunctionReport",
    data() {
        return {
            queryInfo: {
                pagesize: 20,
                pagenum: 1,
                total: 0
            },
            queryData: {
                user: 0,
                timeDate: ['', ''],
                pid: '',
                channelId: '',
                subChannelId: '',
                state: 0
            },
            showPlateStyles: new Set(),
            queryTrueData: {
                startTime: '',
                endTime: '',
                order: null,
                prop: null,
                pid: '',
                channelId: '',
                subChannelId: '',
                state: 0
            },
            users: [{id: 0, name: '全部'},
                {id: 1, name: '新用户'},
                {id: 2, name: '老用户'}],
            stateList: [{id: 0, name: '明细'},
                {id: 1, name: '汇总'}],
            plateRules: [],
            discoverRules: [],
            plateReportList: [],
            channelList: [],
            subChannels:[],
            subChannelList: [],
            watchTag: '',
        }
    },
    methods: {
        selectGoodsByChannelId(val) {
            this.watchTag = val;
            if (val !== null && val !== '' && val !== undefined && val !== '0') {
                this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
                this.subChannels = this.subChannelList.map((item)=>{
                    return item.subChannel;
                })
            }
            if (val === '0') {
                this.subChannelList = [];
                this.subChannels =[];
            }
        },
        selectSubChannel(val) {
            var _this = this;
            this.showPlateStyles = new Set();
            this.queryData.pid = '';
            if (val === '0') {
                    this.plateRules.forEach(function (plateRule) {
                        if (_this.subChannels.length>0){
                            _this.subChannels.forEach(function (item) {
                                if (plateRule.subChannels && plateRule.subChannels.length > 0 && JSON.stringify(plateRule.subChannels).indexOf(item) > -1){
                                    _this.showPlateStyles.add(plateRule);
                                }
                            })
                        }else{
                            _this.showPlateStyles.add(plateRule);
                        }
                });
            } else {
                this.plateRules.forEach(function (plateRule) {
                    if (plateRule.subChannels) {
                        if (plateRule.subChannels && plateRule.subChannels.length > 0 && JSON.stringify(plateRule.subChannels).indexOf(val) > -1) {
                            _this.showPlateStyles.add(plateRule);
                        }
                    } else {
                        _this.showPlateStyles.add(plateRule);
                    }
                })
            }
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;
            this.queryPlateReportList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;
            this.queryPlateReportList();
        },
        query() {
            this.queryInfo.pagenum = 1;
            this.queryPlateReportList();
        },
        searchAll() {
            this.queryPlateReportList();
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '版块日报.xlsx';
            downloadData(
                '/plate/searchPlateReportExcel',
                Object.assign(this.queryTrueData),
                fileName
            )
        },
        queryPlateReportList() {
            this.queryTrueData.startTime = this.queryData.timeDate[0];
            this.queryTrueData.endTime = this.queryData.timeDate[1];
            this.queryTrueData.channelId = this.queryData.channelId;
            this.queryTrueData.pid = this.queryData.pid;
            this.queryTrueData.subChannelId = this.queryData.subChannelId;
            this.queryTrueData.state = this.queryData.state;
            this.queryTrueData.size = this.queryInfo.pagesize;
            this.queryTrueData.page = this.queryInfo.pagenum;
            this.queryTrueData.user = this.queryData.user;
            plateReportSearch(this.queryTrueData).then(resp => {
                this.plateReportList = resp.data.info.list;
                this.$forceUpdate();
                this.queryInfo.total = resp.data.info.totalElements;
            });
        },
        sortChange(order) {
            this.queryTrueData.order = order.order;
            this.queryTrueData.prop = order.prop;
            this.queryPlateReportList();
        }
    },

    watch: {
        watchTag() {
            this.queryData.subChannelId = '';
            this.queryData.pid = '';
        }
    },
    created() {
        this.queryData.timeDate = [utils.TodayUtil.getToday(), utils.TodayUtil.getToday()];
        channelList().then(resp => {
            this.channelList = resp.data.info;
        });
        plateRuleList().then(resp => {
            this.plateRules = resp.data.info;
            eventListByType(1).then(resp => {
                resp.data.info.forEach(each => {
                    each.id = each.whole;
                });
                this.plateRules = this.plateRules.concat(resp.data.info);
                discoverList().then(resp => {
                    this.plateRules = this.plateRules.concat(resp.data.info);
                });
            })
        })


    }
}
</script>

<style scoped>

</style>
